import { combineReducers, createReducer } from '@reduxjs/toolkit';

import {
  discardVehicleFieldsRequested,
  discardVehicleValue,
  garageCleanupRequested,
  removalFromGarageRequested,
  replaceVehicleValue,
  vehicleDiscardingRequested,
  vehicleSelected,
} from 'Core/actions/fitmentSearch/index';
import { resetRequest } from 'Core/actions/request';
import { updateVehicleSelection } from 'Models/vehicle';

import { getInitialVehicleSelection } from './common';

export default combineReducers({
  selection: createReducer(getInitialVehicleSelection(), (builder) =>
    builder
      .addCase(garageCleanupRequested, () => [])
      .addCase(vehicleDiscardingRequested, () => [])
      .addCase(resetRequest, (state, { payload: { discardVehicle } }) => (discardVehicle ? [] : state))
      .addCase(discardVehicleFieldsRequested, (state, action) =>
        state.filter((v) => !action.meta.fieldsToDiscard.includes(v.field)),
      )
      .addCase(removalFromGarageRequested, (state, { meta }) => (meta.wasSelected ? [] : state))
      .addCase(replaceVehicleValue, (state, action) =>
        updateVehicleSelection(state, action.payload, action.meta.fitmentFields),
      )
      .addCase(discardVehicleValue, (state, { payload }) =>
        state.filter((facet) => facet.field !== payload.field),
      )
      .addCase(vehicleSelected, (_state, { payload: { selection } }) => selection),
  ),
});
